module.exports = "/assets/data/d9e7e42fc5bd8a5c94b5f7093a87e80e-BD13.data.json";